<template>
  <component @on-seach="$emit('on-search', $event)" :is="componentLoader">
  </component>
</template>

<script>
export default {
  name: "tasklist",
  props: {
    otCompName: {
      type: String,
      default: () => null
    }
  },
  mounted() {
    if (this.$props.otCompName) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      return () =>
        import(`@/views/modules/report/search/components/${this.otCompName}`);
    }
  },
  methods: {
    loadComponent() {
      this.componentLoader().then(() => {});
    }
  }
};
</script>
